import { Middleware } from "redux";
import { RootState } from "../../../state";
import { serverRequest } from "../../../actions/app/api";
import { APP_URL, PATCH } from "../../../../_shared/constants";
import { UPDATE_PROJECT } from "../../../actions";

export const updateProject: Middleware<unknown, RootState> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    if (action.type === UPDATE_PROJECT.START) {
      const { id, payload, onFinish, ...rest } = action.meta;
      dispatch(
        serverRequest({
          method: PATCH,
          url: `${APP_URL.project.update}/${id}`,
          onFinish,
          payload,
          onSuccess: UPDATE_PROJECT.SUCCESS,
          ...rest,
        })
      );
    }
  };
